'use strict';

export default function routes($stateProvider) {
  'ngInject';
  $stateProvider.state('sites', {
    url: '/sites',
    template: '<sites></sites>',
    authenticate: true
  });
}



// WEBPACK FOOTER //
// ./client/app/sites/sites.routes.js